// extracted by mini-css-extract-plugin
module.exports = {"Welcome":"Header_Welcome__biM0D","Header":"Header_Header__1tHKw"};